import { useState } from 'react';
import TriageQueue from './TriageQueue';
import TriageCall from './TriageCall';
import TriageCoaching from './TriageCoaching';

export default function TriagePage() {
  const [view, setView] = useState('queue');
  const [callId, setCallId] = useState(null);

  const openCall = (id) => {
    setCallId(id);
    setView('call');
  };
  const backToQueue = () => setView('queue');

  const navStyle = (v) => ({
    padding: '6px 14px', borderRadius: 'var(--radius-sm)', fontSize: 12,
    fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s',
    background: view === v ? 'var(--accent-glow)' : 'transparent',
    color: view === v ? 'var(--accent-primary-hover)' : 'var(--text-tertiary)',
    border: view === v ? '1px solid rgba(139,92,246,0.3)' : '1px solid transparent',
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
      <div style={{ display: 'flex', gap: 6, padding: '8px 16px', background: 'var(--bg-secondary)', borderBottom: '1px solid var(--border-color)' }}>
        <div style={navStyle('queue')} onClick={() => setView('queue')}>📋 Call Queue</div>
        <div style={navStyle('call')} onClick={() => setView('call')}>🎙 Call Detail{callId ? ` · ${String(callId).slice(0, 8)}` : ''}</div>
        <div style={navStyle('coaching')} onClick={() => setView('coaching')}>📚 Coaching</div>
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {view === 'queue' && <TriageQueue onOpenCall={openCall} onOpenCoaching={() => setView('coaching')} />}
        {view === 'call' && <TriageCall key={callId || 'none'} callId={callId} onBack={backToQueue} />}
        {view === 'coaching' && <TriageCoaching onOpenCall={openCall} />}
      </div>
    </div>
  );
}
